// i18n.js  
import Vue from 'vue';  
import VueI18n from 'vue-i18n';  
import zh from "./lang/zh.json";
import en from "./lang/en.json";
Vue.use(VueI18n);  
  
const messages = {  
  en: en,  
  zh: zh  
}; 
  
const i18n = new VueI18n({  
  locale: 'zh', // 设置默认语言  
  fallbackLocale: 'zh', // 设置备用语言  
  messages, // 设置资源  
});  
export function changeLang(lang="zh"){
    return new Promise((reslove, reject)=>{
        try{
            //当前语言存在直接切换语言
            if(messages.en.message){
                i18n.locale = lang
                reslove()
            }else{
                //等写en文件请求逻辑
                i18n.locale = lang
                reslove()
            }
        }catch(error){
            reject()
        }
    })
}
export default i18n;